export class JobTypes {
  primaryJobType: JobType;
  secondaryJobTypes: JobType[];
}

export class JobType {
  id: string;
  name: string;
  parentId?: string;
}
